import React, { useState, useRef } from "react";
import { Auth } from "aws-amplify";
import {
  Button,
  CircularProgress,
  Grid,
  TextField,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { onError } from "../libs/errorLib";
import "./Login.scss";
import config from "../config";
import resourcesData from '../constants/resourceMap.js';
import ReCAPTCHA from "react-google-recaptcha";

//let token = "";

//function captchaChange(value) {
//  token = value;
//}

export default function Login() {
  const captchaRef = useRef(null);
  const history = useHistory();
  const { userHasAuthenticated } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [fields, handleFieldChange] = useFormFields({
    username: "",
    password: "",
  });

  const [errorMessage, setErrorMessage] = React.useState("");

  function validateForm() {
    return fields.username.length > 0 && fields.password.length > 0;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setIsLoading(true);

    try {
      if (config.recaptcha.SITEKEY){
        const token = captchaRef.current.getValue();
        captchaRef.current.reset();
        await Auth.signIn(fields.username, fields.password, {captcha: token});
      }else{
        await Auth.signIn(fields.username, fields.password);
      }
      const { attributes } = await Auth.currentAuthenticatedUser();
      userHasAuthenticated(true);
      if (attributes.sub === config.cognito.SUB1_SUB) {
        history.push(resourcesData['sub1'].path);
      } else if (attributes.sub === config.cognito.SUB2_SUB) {
        history.push(resourcesData['sub2'].path);
      } else {
        history.push("/");
      }
    } catch (e) {
      setErrorMessage(onError(e));
      //onError(e);
      setIsLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Grid container direction="row" justifyContent="center">
        <Grid container item className={"loginBox"} direction="column" spacing={1} xs={12} sm={6} lg={4} xl={4}>
          <Grid item>
            <p><strong>Please log in to access resources.</strong></p>
            <TextField
              id="username"
              type="text"
              placeholder="Enter your username"
              name="username"
              variant="outlined"
              size="small"
              value={fields.username}
              onChange={handleFieldChange}
              fullWidth
              required
              autoFocus
            />
          </Grid>
          <Grid item>
            <TextField
              id="password"
              type="password"
              placeholder="Enter your password"
              name="password"
              variant="outlined"
              size="small"
              value={fields.password}
              onChange={handleFieldChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              id="loginButton"
              type="submit"
              disabled={!validateForm()}
            >
              Login
              {isLoading ? (
                <CircularProgress size="1em" className="loadingSpin" />
              ) : (
                ""
              )}
            </Button>
            {errorMessage && <div className="error"> {errorMessage} </div>}
            {config.recaptcha.SITEKEY?(<ReCAPTCHA className="recaptchaElement"
  sitekey = {config.recaptcha.SITEKEY}
  //onChange = {captchaChange}
  ref = {captchaRef}
  onExpired={() => {this.setState({});
  }}
  //size="invisible"
/>):""}
          </Grid>
          {config.public.CONTACT?
          (<Grid item>
            <p>
              <br />
              If you've forgotten your username/password, please contact{" "}
              <a href={"mailto:"+config.public.CONTACT}>{config.public.CONTACT}</a>
            </p>
          </Grid>):""
          }
        </Grid>
      </Grid>
      <br /><br />
   </form>
  );
}